export function confirmBatches(files, maxFiles) {
  const items = files || [];
  if (items.length === 0) return [];

  const batches = [];
  for (let index = 0; index < items.length; index += maxFiles) {
    const chunk = items.slice(index, index + maxFiles);
    batches.push({
      files: chunk,
      finalize: index + maxFiles >= items.length,
    });
  }
  return batches;
}

export async function postConfirmBatches(postFn, confirmUrl, files, maxFiles, onConfirmed = () => {}) {
  const payloads = confirmBatches(files, maxFiles);
  for (const payload of payloads) {
    const confirmResponse = await postFn(confirmUrl, {
      body: JSON.stringify(payload),
      contentType: "application/json",
      responseKind: "json",
    });
    if (!confirmResponse.ok) {
      throw new Error(`confirm failed (${confirmResponse.status})`);
    }
    const data = await readConfirmJson(confirmResponse);
    onConfirmed(data);
    if (payload.finalize && data.completed !== true) {
      throw new Error("confirm incomplete");
    }
  }
  return payloads;
}

async function readConfirmJson(confirmResponse) {
  if (confirmResponse.json == null) return {};
  return await confirmResponse.json;
}
